import Vue from 'vue'
import VueMeta from 'vue-meta'
import '@/assets/custom.css'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import router from './router'
import i18n from './i18n'
import store from './store'
import { getBrandInfo, getBanner, getQuickBar, getCarousel } from '@/api/brand'
import { info } from '@/api/user'
import { toErrorPage, loadDynamicCss, setCurrencySymbol } from '@/utils/tool'
import '@/utils/filters'
import { getCurrentLangPackVer } from '@/utils/config'
import Cookies from 'js-cookie'
import CustomSocket from '@/services/socket'
import { forceApp, showNotice, toMaintainPage, toForbiddenPage } from '@/utils/tool'
import App from './App.vue'

if (process.env.VUE_APP_ENV === 'production' && location.protocol === 'http:') {
  location.href = location.href.replace(/^http:/, 'https:')
}

Vue.config.productionTip = false

Vue.use(VueMeta, {
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})

// 四舍五入到小数点后两位
Vue.filter('numberFormat', function(price) {
  if (!isNaN(price) && price !== null) {
    return parseFloat(Math.floor(price * 100) / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return price
})

// 保留三位小数、小數位數皆為 0 時 只顯示 '0'
Vue.filter('numberFormatThird', function(price) {
  if (!isNaN(price) && price !== null) {
    const formatted = parseFloat(price).toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parseFloat(formatted) === 0 ? '0' : formatted.replace(/(\.0{1,})$/, '')
  }
  return price
})

// 開啟socket
Vue.use(CustomSocket)

Vue.use(Toast)

// 不能在iframe中
// if (window !== window.top) {
//   window.top.location.href = window.location.href
// }

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.needRedirect && localStorage.getItem('redirectAfterLogin')) {
    if (!store.getters.token) {
      setTimeout(() => {
        store.commit('SET_LOGIN_OPEN', true)
      }, 200)
    }
  }
  if (to.meta.metaInfo) {
    store.commit('CHANGE_META_INFO', to.meta.metaInfo)
  }

  const shareCode = to.query.share_code
  if (shareCode) {
    store.commit('SET_SHARE_CODE', shareCode)
    localStorage.setItem('shareCode', shareCode)
  }
  // 需要登入的頁面判斷
  if (to.meta && to.meta.needLogin) {
    if (!store.getters.token) {
      router.push({ path: '/' }).catch(() => {
      })
      setTimeout(() => {
        store.commit('SET_FORGET_OPEN', false)
        store.commit('SET_LOGIN_OPEN', true)
      }, 0.1)
    }
  }
  store.commit('SET_HIDE_MOBILE_NAV', false)

  if (to.meta.needCookie) {
    store.commit('SET_COOKIE', true)
  } else {
    store.commit('SET_COOKIE', false)
  }
  if (to.query.btag) {
    store.commit('SET_BTAG_CODE', to.query.btag)
  }

  if (store.getters.token && to.meta.isClose) {
    showNotice(i18n.t('Bao.coming_soon'))
    next(false)
  } else if (store.getters.token && store._vm.memberInfo.member_type === 3 && to.meta.isLitePlayer) {
    showNotice(i18n.t('Bao.lite_player_notice'))
    next(false)
  } else {
    next()
  }
})

Vue.directive('visible', function(el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden'
})

store.commit('SET_LOADING_COUNT_ZERO')
store.commit('SET_LOADING', true)
store.commit('SET_LOAD_COMPLETED', false)

store.commit('SET_HIDE_MOBILE_NAV', false)

let brandCode = process.env.VUE_APP_BRAND_CODE // 開發環境指定brand code
if (brandCode === '') {
  brandCode = window.location.host || document.location.host // 剛開始載入先用host取資訊
}

// 重新取相關資訊
store.commit('SET_BRAND_INFO', null)
store.commit('SET_NOTICE_MESSAGE', null)
store.commit('SET_AD_MESSAGE', null)

// 偵測與系參數
let language = new URL(window.location.href || document.location.href).searchParams.get('language') || Cookies.get('language')
let brandObject = {}
if (language !== null && language !== undefined) {
  brandObject = { code: brandCode, language: language }
} else {
  brandObject = { code: brandCode }
}

// 偵測網址token
const queryToken = new URL(window.location.href || document.location.href).searchParams.get('token')
if (queryToken) {
  store.commit('SET_TOKEN', queryToken)
}

// 呈現ui
new Vue({
  router,
  i18n,
  store,
  created() {
    // API取得聽資訊
    getBrandInfo(brandObject).then((response) => {
      // 自訂js code
      if (response.data.data.brandInfo.custom_script !== '') {
        const script = document.createElement('script')
        script.setAttribute('type', 'text/javascript')
        script.setAttribute('language', 'javascript')
        const inlineScript = document.createTextNode(response.data.data.brandInfo.custom_script)
        script.appendChild(inlineScript)
        document.body.insertAdjacentElement('afterend', script)
      }

      if (forceApp(this.$router.currentRoute.name, response.data.data.permissionInfo.mobile_force_app)) {
        setTimeout(function() { window.location = response.data.data.urlInfo.appDownloadUrl }, 5000)
        showNotice(this.$t('Bao.downAppNotice'), function() {
          window.location = response.data.data.urlInfo.appDownloadUrl
        }, false)
      }

      store.commit('SET_BRAND_INFO', response.data.data)

      loadDynamicCss()

      setCurrencySymbol()

      document.title = response.data.data.brandInfo.site_title

      // 電話代碼
      const phoneCode = response.data.data.supportPhoneCode
      store.commit('SET_SUPPORT_PHONE_CODE', phoneCode)

      // 圖片
      const brandImage = response.data.data.brandImage
      store.commit('SET_BRAND_IMAGE', brandImage)

      // 首頁輪播
      getCarousel().then(response => {
        store.commit('SET_CAROUSEL', response.data.data)
      })

      // 客服
      getQuickBar().then(response => {
        store.commit('SET_QUICKBARS', response.data.data)
      })

      // 語系
      const browserLang = (navigator.language || navigator.userLanguage).toLowerCase()
      let lang
      switch (browserLang) {
        case 'ja':
        case 'ja-jp':
          lang = 'jp'
          break
        case 'en':
        case 'en-us':
        case 'en-gb':
          lang = 'en'
          break
        case 'zh':
        case 'zh-tw':
          lang = 'tw'
          break
        default:
          lang = 'en' // Default language if no match is found
      }
      const languages = response.data.data.brandInfo.language

      if (!languages || languages.length === 0) {
        toErrorPage('Cant get language')
      } else {
        store.commit('SET_SUPPORT_LANGUAGES', languages)
        if (!language) {
          if (languages.includes(lang)) {
            language = lang
          } else { language = languages[0] }
        }

        store.commit('SET_LANGUAGE', language)
        // 確定翻譯檔版本 & 取翻譯內容
        const prevLangPackVer = localStorage.getItem('langPackVer')
        const currentLangPackVer = getCurrentLangPackVer()
        const localLangMessage = localStorage.getItem(`langMsg-${language}`) // 抓cookie值，第一次載入時抓使用者偏好
        let langFilePath = ''

        if (process.env.VUE_APP_ENV === 'development') {
          langFilePath = `/locales/${language}.json`
        } else {
          langFilePath = `/locales/${language}.${currentLangPackVer}.json`
        }

        const getRemoteLangMessage = () => {
          fetch(langFilePath)
            .then(response => {
              if (!response.ok) {
                throw new Error('HTTP error ' + response.status)
              }
              return response.json()
            })
            .then(json => {
              const Bao = json
              const messages = { ...i18n.messages[language], Bao }
              i18n.setLocaleMessage(language, messages)

              store.commit('SET_LOADING', false)
              store.commit('SET_LOAD_COMPLETED', true)

              localStorage.setItem('langPackVer', currentLangPackVer)
              localStorage.setItem(`langMsg-${language}`, JSON.stringify(messages)) // 第一次載入時設為使用者瀏覽器偏好語言
            })
            .catch(function(err) {
              console.log(err)
            })
        }

        // 如果prevLangPackVer沒值或是版本較舊, 則從server取翻譯, 並更新localstorage
        if (prevLangPackVer && localLangMessage && prevLangPackVer >= currentLangPackVer) {
          try {
            i18n.setLocaleMessage(language, JSON.parse(localLangMessage))// 直接從 localstorage 取
            store.commit('SET_LOADING', false)
            store.commit('SET_LOAD_COMPLETED', true)
          } catch (err) {
            console.log(err)
            getRemoteLangMessage()
          }
        } else {
          // 從遠端取並更新 localstorage
          getRemoteLangMessage()
        }
      }

      getBanner().then(response => {
        store.commit('SET_BANNERS', response.data.data)
      })

      // 如果有token 強制更新個人資料
      if (store.getters.token) {
        info().then(response => {
          const reqData = response.data
          store.dispatch('SetUserData', reqData.data)
        })
      }
      store.dispatch('UpdateCsUrl')
    }).catch((e) => {
      console.log(e)
      const data = e.response.data.data
      if (data) {
        if (data.type === 'maintain') {
          toMaintainPage(data.content)
        } else if (data.type === 'ip_forbidden') {
          toForbiddenPage(data.content)
        }
      }

      if (e.response.status === 403) {
        toForbiddenPage(e.response.data.msg)
      }

      store.commit('SET_LOADING', false)
      // 基本參數查不到 導向錯誤頁
      store.commit('SET_LOAD_COMPLETED', true)

      store.commit('SET_ERROR_MESSAGE', data.content)
      router.push({ path: '/critical' }, () => {
      })
    })
  },
  render: h => h(App)
}).$mount('#app')
